import { useRef, useState } from 'react';
import { View } from '@picsart/view';
import { Image } from '@picsart/image';

import getGridImageSizes from 'utils/images/getGridImageSizes';
import useMemoSelector from 'hooks/useMemoSelector';
import { getBatchActiveColor, getBatchActiveTexture } from 'store/batch/selectors';

import testIds from './testIds';
import useStyles from './styles';

export interface IRbGridItem {
  imgSrc: string;
  boxWidth: number;
  boxHeight: number;
  isPreviewMode?: boolean;
}

const RemoveBgGridItem = ({ imgSrc, boxWidth, boxHeight, isPreviewMode }: IRbGridItem) => {
  const { activeColor, activeTexture } = useMemoSelector(state => ({
    activeColor: getBatchActiveColor(state),
    activeTexture: getBatchActiveTexture(state),
  }));

  const imageRef = useRef<HTMLImageElement>(null);
  const [{ width, height }, setImageBoxSize] = useState({
    width: '0',
    height: '0',
  });

  const handleImageSize = (wrapperWidth: number, wrapperHeight: number) => {
    const imgBoxSizes = getGridImageSizes(wrapperWidth, wrapperHeight, imageRef.current as HTMLImageElement);
    setImageBoxSize(imgBoxSizes);
  };

  const classes = useStyles({
    bgColor: activeColor,
    texture: activeTexture?.url,
    width,
    height,
    ...(isPreviewMode && { boxHeight, boxWidth }),
  });

  return (
    <View className={classes.gridImageWrap} data-testid={testIds.removeBgGridItemContainer}>
      <View className={classes.gridImageBox} width={boxWidth} height={boxHeight}>
        {activeTexture && <Image src={activeTexture?.url} alt="img" className={classes.gridImage} data-testid={testIds.removeBgGridItemTexture} />}
        <Image ref={imageRef} className={classes.gridImage} src={imgSrc} onLoad={() => handleImageSize(boxWidth, boxHeight)} alt="img" data-testid={testIds.removeBgGridItemImage} />
      </View>
    </View>
  );
};

export default RemoveBgGridItem;
